import React from 'react'

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 text-gray-600 py-6 mt-auto dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm">
          Made by <span className="text-gray-900 font-medium dark:text-white">tikisan</span>
        </p>
      </div>
    </footer>
  )
} 